export default __webpack_public_path__ + "static/media/cupomDescontoAgencias.5cb270b6.webp";